import { render } from "./Uriagelist.vue?vue&type=template&id=26c65a76&scoped=true&ts=true"
import script from "./Uriagelist.vue?vue&type=script&lang=ts"
export * from "./Uriagelist.vue?vue&type=script&lang=ts"

import "./Uriagelist.vue?vue&type=style&index=0&id=26c65a76&scoped=true&lang=css"
import "./Uriagelist.vue?vue&type=style&index=1&id=26c65a76&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c65a76"]])

export default __exports__